import { render } from "./Teachers.vue?vue&type=template&id=2e57f92a&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"

import "./Teachers.vue?vue&type=style&index=0&id=2e57f92a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e57f92a"]])

export default __exports__